export default __webpack_public_path__ + "static/media/product-14.ee2d9abf.jpg";